import { WithPanelRightPortal } from 'hocs';

import Button from './Button';

export default WithPanelRightPortal(Button);
